<section class="cmn-innerpage-wrapper add-project-inventory">
  <h2 class="cmn-inner-heading">
    {{ invoiceId ? "Edit Vendor Invoice" : "New Vendor Invoice" }}
  </h2>

  <form [formGroup]="newInvoiceForm">
    <div class="chart-account-form-wrapper">
      <!-- Invoice No -->
      <div class="form-wrapper">
        <label for="">Bill No <span class="red">*</span></label>
        <mat-form-field>
          <input
            matInput
            placeholder="Enter Bill No"
            formControlName="billNo"
          />
        </mat-form-field>
        <div class="custom-error">
          <mat-error
            *ngIf="
              newInvoiceForm.get('billNo')?.touched &&
              newInvoiceForm.get('billNo')?.hasError('required')
            "
          >
            Bill number is required.
          </mat-error>
        </div>
      </div>

      <!-- vendor ID -->
      <div class="form-wrapper">
        <label for="">Vendor<span class="red">*</span></label>
        <mat-form-field appearance="fill">
          <mat-label>Select Vendor</mat-label>
          <mat-select formControlName="vendorId">
            <mat-option>
              <ngx-mat-select-search
                [placeholderLabel]="'Search'"
                [noEntriesFoundLabel]="'No vendors found'"
                (input)="onSearch($event)"
              ></ngx-mat-select-search>
            </mat-option>
            <mat-option
              *ngFor="let vendor of vendors"
              [value]="vendor.id"
            >
              {{ vendor.vendorName }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="custom-error">
          <mat-error
            *ngIf="
              newInvoiceForm.get('vendorId')?.touched &&
              newInvoiceForm.get('vendorId')?.hasError('required')
            "
          >
            Vendor is required.
          </mat-error>
        </div>
      </div>

      <div class="form-wrapper">
        <label for="">Purchase Order<span class="red">*</span></label>
        <mat-form-field appearance="fill">
          <mat-label>Select Purchase Order</mat-label>
          <mat-select formControlName="purchaseOrderId">
            <mat-option>
              <ngx-mat-select-search
                [placeholderLabel]="'Search'"
                [noEntriesFoundLabel]="'No purchase order found'"
                (input)="onSearchPurchaseOrders($event)"
              ></ngx-mat-select-search>
            </mat-option>
            <mat-option
              *ngFor="let order of purchaseOrderData"
              [value]="order.id"
            >
              {{ order.purchaseOrderNo }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="custom-error">
          <mat-error
            *ngIf="
              newInvoiceForm.get('purchaseOrderId')?.touched &&
              newInvoiceForm.get('purchaseOrderId')?.hasError('required')
            "
          >
            Purchase order is required.
          </mat-error>
        </div>
      </div>


      <!-- Order ID -->
      <div class="form-wrapper">
        <label for="">Account<span class="red">*</span></label>
        <mat-form-field appearance="fill">
          <mat-label>Select account</mat-label>
          <mat-select formControlName="accountId">
            <mat-option>
              <ngx-mat-select-search
                [placeholderLabel]="'Search'"
                [noEntriesFoundLabel]="'No accounts found'"
                (input)="onSearchAccounts($event)"
              ></ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let account of accountsData" [value]="account.id">
              {{ account.accountName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div class="custom-error">
          <mat-error
            *ngIf="
              newInvoiceForm.get('accountId')?.touched &&
              newInvoiceForm.get('accountId')?.hasError('required')
            "
          >
            Account is required.
          </mat-error>
        </div>
      </div>

      <!-- Due Date -->
      <div class="form-wrapper">
        <label for="">Due Date <span class="red">*</span></label>
        <mat-form-field appearance="fill">
          <input
            matInput
            [matDatepicker]="picker"
            placeholder="Choose a date"
            formControlName="dueDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <div class="custom-error">
          <mat-error
            *ngIf="
              newInvoiceForm.get('dueDate')?.touched &&
              newInvoiceForm.get('dueDate')?.hasError('required')
            "
          >
            Due Date is required.
          </mat-error>
        </div>
      </div>
    </div>

    <div class="item-service-adding-table-wrapper" formArrayName="items">
      <table>
        <thead>
          <tr>
            <th>Item Name <span class="red">*</span></th>
            <th>Description</th>
            <th>Quantity <span class="red">*</span></th>
            <th>Unit Price<span class="red">*</span></th>
            <th>Sub Total</th>
            <th>VAT(5%)</th>
            <th>Total Amount</th>
          </tr>
        </thead>

        <tbody>
          <tr
            *ngFor="let item of items.controls; let i = index"
            [formGroupName]="i"
          >
            <!-- Item description data -->
            <td>
              <div class="form-wrapper">
                <div>
                  <mat-form-field>
                    <input
                      matInput
                      placeholder="Item Name"
                      formControlName="itemName"
                      readonly
                    />
                  </mat-form-field>
                  <div
                    class="custom-error"
                    *ngIf="item.get('itemName')?.touched"
                  >
                    <span>
                      <mat-error
                        *ngIf="item.get('itemName')?.errors?.['required']"
                      >
                        Item is required.
                      </mat-error>
                    </span>
                  </div>
                </div>
              </div>
            </td>

            <!-- Description  -->
            <td>
              <div class="form-wrapper">
                <div>
                  <mat-form-field>
                    <input
                      matInput
                      placeholder="Description"
                      formControlName="description"
                      readonly
                    />
                  </mat-form-field>
                </div>
              </div>
            </td>
            <!-- Quanitity data -->
            <td>
              <div class="form-wrapper">
                <mat-form-field>
                  <input
                    matInput
                    placeholder="quantity"
                    formControlName="quantity"
                    readonly
                    (keypress)="allowOnlyInteger($event)"
                    (paste)="blockPasteNonInteger($event)"
                  />
                </mat-form-field>
                <div class="custom-error">
                  <span>
                    <mat-error
                      *ngIf="
                        item.get('quantity')?.touched &&
                        item.get('quantity')?.hasError('required')
                      "
                      >Quantity is required.</mat-error
                    >
                  </span>
                  <span>
                    <mat-error
                      *ngIf="item.get('quantity')?.hasError('nonNegative')"
                      >Quantity must be greater than 0.</mat-error
                    >
                  </span>
                </div>
              </div>
            </td>
            <!-- Rate data -->
            <td>
              <div class="form-wrapper">
                <mat-form-field>
                  <input
                   matInput
                    placeholder="Unit price" 
                    formControlName="rate"
                    readonly
                    (keypress)="allowOnlyNumberWithDecimal($event)"
                    (paste)="blockPaste($event)"
                    />
                </mat-form-field>
                <div class="custom-error">
                  <span>
                    <mat-error
                      *ngIf="
                        item.get('rate')?.touched &&
                        item.get('rate')?.hasError('required')
                      "
                      >Unit price is required.</mat-error
                    >
                  </span>
                  <span>
                    <mat-error *ngIf="item.get('rate')?.hasError('nonNegative')"
                      >Unit price cannot be negative.</mat-error
                    >
                  </span>
                </div>
              </div>
            </td>

            <td>
              <div class="form-wrapper">
                <mat-form-field>
                  <input
                    matInput
                    placeholder="Sub Total"
                    formControlName="subTotal"
                    readonly
                  />
                </mat-form-field>
                <div class="custom-error">
                  <span>
                    <mat-error
                      *ngIf="
                        item.get('subTotal')?.touched &&
                        item.get('subTotal')?.hasError('required')
                      "
                      >Sub Total is required.</mat-error
                    >
                  </span>
                  <span>
                    <mat-error
                      *ngIf="item.get('subTotal')?.hasError('nonNegative')"
                      >Sub Total cannot be negative.</mat-error
                    >
                  </span>
                </div>
              </div>
            </td>

            <!-- Vat tax Data -->
            <td>
              <div class="form-wrapper">
                <mat-form-field>
                  <input
                    matInput
                    placeholder="VAT"
                    formControlName="tax"
                    type="number"
                    readonly
                  />
                </mat-form-field>
                <div class="custom-error">
                  <span>
                    <mat-error
                      *ngIf="
                        item.get('tax')?.touched &&
                        item.get('tax')?.hasError('required')
                      "
                      >VAT is required.</mat-error
                    >
                  </span>
                  <span>
                    <mat-error *ngIf="item.get('tax')?.hasError('nonNegative')"
                      >VAT cannot be negative.</mat-error
                    >
                  </span>
                </div>
              </div>
            </td>
            <!-- Total amount data -->
            <td>
              <div class="form-wrapper">
                <mat-form-field>
                  <input
                    matInput
                    placeholder="Total Amount"
                    formControlName="totalAmount"
                    type="number"
                    readonly
                  />
                </mat-form-field>
                <div class="custom-error">
                  <span>
                    <mat-error
                      *ngIf="
                        item.get('totalAmount')?.touched &&
                        item.get('totalAmount')?.hasError('required')
                      "
                    >
                      Amount is required.
                    </mat-error>
                  </span>
                </div>
              </div>
              <!-- <span class="delete">
                <img
                  src="../../../assets/images/icons/icon-close.svg"
                  alt="Delete"
                  (click)="onRemoveNewlyAddedItems(i)"
                />
              </span> -->
            </td>
          </tr>
        </tbody>
      </table>
      <!-- <button type="button" (click)="addItem()">
        <img src="../../../assets/images/icons/icon-add-color.svg" alt="Add" />
        Add
      </button> -->
    </div>

    <div class="notes-tatal-amount-container">
      <div class="empty-div"></div>
      <div class="empty-div"></div>


      <div class="amount-table-div">
        <div>
          <h6>
            SubTotal<span>: {{ currencyCode }} {{ overallSubTotal | number : "1.2-2" }}</span>
          </h6>
          <h6>
            VAT (5%)<span>: {{ currencyCode }} {{ overallVat | number : "1.2-2" }}</span>
          </h6>
          <!-- <h6 *ngIf="currencyCode !== 'AED'">
            Total Amount in {{currencyCode}} <span>: {{ currencyCode }} {{ totalAmount | number : "1.2-2" }}</span>
          </h6>
          <h6 *ngIf="currencyCode !== 'AED'">
            Exchange Rate<span>: {{ exchangeRate }}</span>
          </h6> -->
        </div>
        <div>
          <h4>
            Total Amount<span
              >: AED {{ overallTotalAmount | number : "1.2-2" }}</span
            >
          </h4>
        </div>
      </div>
    </div>

    <div class="submit-btn-wrapper">
      <button class="cmn-cancel-btn" type="button" (click)="onCancel()">
        Cancel
      </button>
      <ng-container *ngIf="billData?.invoiceStatus !== 'Pending'">
      <button class="cmn-next-btn" type="button" (click)="onSubmit('Draft')">
        Save as draft
      </button>
      </ng-container>

      <button class="cmn-next-btn" type="button" (click)="onSubmit('Pending')">
        Save
      </button>
    </div>
  </form>
</section>
